package com.eladfinish.bible.contest.common

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.eladfinish.bible.contest.platform.haptics.vibrateIfSupported

// The Vibration API has no named effects, only durations: a short tick per step.
private class WebReorderHapticFeedback : ReorderHapticFeedback() {
    override fun performHapticFeedback(type: ReorderHapticFeedbackType) {
        val milliseconds = when (type) {
            ReorderHapticFeedbackType.START -> 15
            ReorderHapticFeedbackType.MOVE -> 5
            ReorderHapticFeedbackType.END -> 10
        }
        vibrateIfSupported(milliseconds)
    }
}

@Composable
actual fun rememberReorderHapticFeedback(): ReorderHapticFeedback =
    remember { WebReorderHapticFeedback() }
